import React from "react"
import { GrServicePlay } from "react-icons/gr"
import WelcomeIMG from "assets/images/Welcome1.webp"
import { FaArrowRightToBracket } from "react-icons/fa6"
const Welcome = () => {
  return (
    <div className="p-4">
      <div className="row">
        <div className="col-xl-8 d-flex flex-column pe-5 pt-4">
          <h2 id="why-us" className=" color-purple fw-bold mt-2 mb-4">
            Welcome to Zithas Portfolio
          </h2>
          {/* India Content */}
          <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              At Zithas Technologies, with our head office in Vadodara, Gujarat, we’ve been at the forefront of digital transformation for Indian enterprises—empowering MSMEs, startups, and large organizations with affordable, scalable solutions.
            </h5>
          </div>
          <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              <FaArrowRightToBracket className="me-2" />
              We specialize in automation systems designed to support Indian business flows, including multilingual interfaces and regional integrations.
            </h5>
          </div>
          <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              <FaArrowRightToBracket className="me-2" />
              Our dedicated Indian support team ensures rapid response times and seamless real-time collaboration.
            </h5>
          </div>
          <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              <FaArrowRightToBracket className="me-2" />
              We align with the Make in India and Digital India initiatives to support government and private digital ecosystems.
            </h5>
          </div>
          <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              <FaArrowRightToBracket className="me-2" />
              Trusted by 100+ Indian businesses across industries like healthcare, education, retail, and manufacturing.
            </h5>
          </div>

          {/* Uk Content */}
          {/* <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              Zithas Technologies is a trusted digital partner for UK businesses, offering intelligent systems that are secure, scalable, and tailored for British business environments.
            </h5>
          </div>
          <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              Our UK regional office is located in Bristol, with operations active across London, Manchester, and Birmingham.
            </h5>
          </div>
          <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              <FaArrowRightToBracket className="me-2" />
              We ensure full GDPR compliance and adhere to UK-specific data residency laws.
            </h5>
          </div>
          <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              <FaArrowRightToBracket className="me-2" />
              Supporting both SMBs and enterprises, we lead digital transformation initiatives with measurable outcomes.
            </h5>
          </div>
          <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              <FaArrowRightToBracket className="me-2" />
              Tailored solutions for eCommerce, legal-tech, and professional services industries.
            </h5>
          </div>
          <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              <FaArrowRightToBracket className="me-2" />
              Locally adapted delivery frameworks to meet evolving regional demands.
            </h5>
          </div> */}

          {/* USA content */}
          {/* <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              Zithas Technologies partners with innovative American companies to deliver automation tools, CRM platforms, and bespoke software solutions designed to match the pace and scale of the U.S. market.
            </h5>
          </div>
          <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              <FaArrowRightToBracket className="me-2" />
              Our engineering processes are optimized for compliance-focused sectors such as healthcare, fintech, and logistics.
            </h5>
          </div>
          <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              <FaArrowRightToBracket className="me-2" />
              Seamless integration with leading US platforms including QuickBooks, Salesforce, and Shopify.
            </h5>
          </div>
          <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              <FaArrowRightToBracket className="me-2" />
              Agile methodologies ensure timely launches, scalability, and rapid iteration.
            </h5>
          </div>
          <div className="d-flex">
            <h5 className="mb-4 lh-lg">
              <FaArrowRightToBracket className="me-2" />
              We provide dedicated account managers and support aligned with US time zones for seamless collaboration.
            </h5>
          </div> */}
        </div>
        <div className="col-xl-4 ps-5 mt-3 mt-xl-0 mt-md-0">
          <div className="img-bg">
            <img src={WelcomeIMG} className="w-100 object-fit-cover"></img>
          </div>
        </div>
      </div>
      <div className="mt-5">
        <h2 id="why-us" className=" color-purple fw-bold mb-5">
          Explore Our Wide Range of Services
        </h2>
        <div className="row mt-3">
          <div className="col-xl-3 mb-3 mb-md-0 mb-xl-0  text-center">
            <a
              href="https://www.zithas.com/website-development"
              target="__blank"
            >
              <div className="Service-card">
                <GrServicePlay fontSize={40} className="text-dark" />
                <h4 className="text-dark fw-bold mt-3 mb-0">Web Development</h4>
              </div>
            </a>
          </div>
          <div className="col-xl-3 mb-3 mb-md-0 mb-xl-0 text-center">
            <a
              href="https://www.zithas.com/mobile-apps-development"
              target="__blank"
            >
              <div className="Service-card">
                <GrServicePlay fontSize={40} className="text-dark" />
                <h4 className="text-dark fw-bold mt-3 mb-0">App Development</h4>
              </div>
            </a>
          </div>
          <div className="col-xl-3 mb-3 mb-md-0 mb-xl-0 text-center">
            <a href="https://www.zithas.com/digital-marketing" target="__blank">
              <div className="Service-card">
                <GrServicePlay fontSize={40} className="text-dark" />
                <h4 className="text-dark fw-bold mt-3 mb-0">Marketing</h4>
              </div>
            </a>
          </div>
          <div className="col-xl-3 mb-3 mb-md-0 mb-xl-0  text-center">
            <a
              href="https://www.zithas.com/seo-management-packages"
              target="__blank"
            >
              <div className="Service-card">
                <GrServicePlay fontSize={40} className="text-dark" />
                <h4 className="text-dark fw-bold mt-3 mb-0">SEO</h4>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Welcome
